import { createFileRoute } from "@tanstack/react-router";
import { VesselsListPage } from "~/pages/vessels/VesselsListPage";
export const Route = createFileRoute("/_authenticated/vessels/")({ component: VesselsListPage });
